import React from 'react';
import ClassAssembly  from 'views/ClassAssembly6C';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;